function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { defineComponent, computed, getCurrentInstance } from "vue";
import Navbar from "./navbar.vue";
import Aside from "./aside/index.vue";
import ToTop from "@pt/components/totop.vue";
import XieLunYan from "@com/components/xie-lun-yan";
// import DownloadTaskDialog from '@pt/components/downloadTaskDialog.vue'
import { routerWhiteList } from "@pt/config/router";
import Uploader from "@pt/views/pt-entry/creative-assets/media/uploader.vue";
import BalanceAlert from "./components/balance-alert.vue";
export default defineComponent({
    components: {
        Navbar: Navbar,
        Aside: Aside,
        ToTop: ToTop,
        Uploader: Uploader,
        XieLunYan: XieLunYan,
        BalanceAlert: BalanceAlert
    },
    setup: function setup(props) {
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var store = root.$store;
        var handleDragEnter = function(event) {
            var blackList = [
                "creative-assets.media.resources.detail"
            ];
            if (!(root.$route.name || "").includes("creative-assets.media")) {
                console.log("\u53EA\u6709\u521B\u610F\u8D44\u4EA7\u5E93\u624D\u6709\u62D6\u62FD\u4E0A\u4F20\u529F\u80FD");
                return;
            }
            if (store.state.assets.uploader.freeSize < 0 && store.state.assets.uploader.freeSize !== -1) {
                console.log("\u6CA1\u6709\u53EF\u7528\u7A7A\u95F4");
                return;
            }
            if (root && root.$route && root.$route.name && blackList.includes(root.$route.name)) {
                console.log("\u9ED1\u540D\u5355\u62E6\u622A");
                return;
            }
            var dropItems = _toConsumableArray(event.dataTransfer.items);
            if (dropItems.every(function(item) {
                return item.kind !== "file";
            })) {
                console.warn("\u62D6\u62FD\u7684\u5143\u7D20\u975E\u6587\u4EF6", dropItems.map(function(item) {
                    return item.type;
                }).join(), dropItems.map(function(item) {
                    return item.kind;
                }).join());
                return;
            }
            console.log("\u5F53\u524D\u7D20\u6750\u7C7B\u578B\u662F", dropItems.map(function(item) {
                return item.type;
            }).join(), dropItems.map(function(item) {
                return item.kind;
            }).join(), dropItems.length);
            store.commit("assets/uploader/setDialogVisible", true);
        };
        var notInEditor = computed(function() {
            // 黑名单，编辑器不显示totop组件
            var blackList = [
                "common-template.custom",
                "common-template.multi-custom",
                "template.custom",
                "template.dco",
                "template.multi-custom", 
            ];
            return !blackList.includes(root.$route.name);
        });
        var isEditGmaker = computed(function() {
            var gMaker = [
                "common-template.custom",
                "common-template.dco",
                "common-template.multi-custom", 
            ];
            return gMaker.includes(root.$route.name);
        });
        var isEditDmaker = computed(function() {
            var ref;
            var dMaker = [
                "template.custom",
                "template.dco",
                "template.multi-custom", 
            ];
            return ((ref = root.$route.name) === null || ref === void 0 ? void 0 : ref.indexOf("common-template")) !== -1 || dMaker.indexOf(root.$route.name) !== -1;
        });
        var downloadTaskVisible = computed(function() {
            // 白名单之外的页面才需要展示 download-task-dialog 组件
            return routerWhiteList.indexOf(root.$route.path) === -1;
        });
        var showUploader = computed(function() {
            return (root.$route.name || "").includes("creative-assets.media");
        });
        return {
            handleDragEnter: handleDragEnter,
            notInEditor: notInEditor,
            isEditDmaker: isEditDmaker,
            downloadTaskVisible: downloadTaskVisible,
            showUploader: showUploader,
            isEditGmaker: isEditGmaker
        };
    }
});
